import React from 'react';
import {Button} from 'react-bootstrap';
import classNames from './joyride.module.css';
import {useTranslation} from 'react-i18next';

export const JoyRideTooltip = ({
  continuous,
  index,
  step,
  backProps,
  closeProps,
  primaryProps,
  skipProps,
  size,
  tooltipProps,
  isLastStep,
  ...rest
}) => {
  const {t} = useTranslation();

  return (
    <div
      {...tooltipProps}
      className={index === 0 ? classNames['tooltip0'] : classNames['tooltip']}
    >
      {step.title && <h2>{step.title}</h2>}
      <p>{step.content}</p>
      <div
        className={
          index > 0
            ? `d-flex justify-content-end ${classNames['dir-row-reverse']} ${classNames['splash-align-center']}`
            : `d-flex justify-content-end ${classNames['pd-24']} ${classNames['splash-align-end']}`
        }
        style={{flex: 1}}
      >
        {index > 0 && !isLastStep && (
          <div style={{display: 'flex', flex: 1, justifyContent: 'flex-end'}}>
            <Button
              className={classNames['splash-btn-all']}
              style={{marginRight: '0.5rem'}}
              {...backProps}
            >
              {t('Previous')}
            </Button>
            <Button className={classNames['splash-btn-all']} {...primaryProps}>
              {t('Next')}
            </Button>
          </div>
        )}
        {continuous && !isLastStep && (
          <div>
            {index === 0 && (
              <div className={classNames['splash-btn-block']}>
                <span>{t('To continue walkthrough')}</span>
                <Button
                  className={classNames['splash-btn-block-button']}
                  {...primaryProps}
                >
                  {t('Click Here')}
                </Button>{' '}
                <Button
                  {...skipProps}
                  className={classNames['splash-skip-btn-primary']}
                >
                  {t('Skip')}
                </Button>
              </div>
            )}
          </div>
        )}
        {isLastStep && (
          <div style={{display: 'flex', flexDirection: 'row-reverse', flex: 1}}>
            <Button className={classNames['splash-btn-all']} {...closeProps}>
              {t('Close')}
            </Button>
            <Button
              style={{marginRight: '0.5rem'}}
              className={classNames['splash-btn-all']}
              {...backProps}
            >
              {t('Previous')}
            </Button>
          </div>
        )}
        {index > 0 && (
          <div>
            {' '}
            <Button {...skipProps} className={classNames['splash-skip-btn']}>
              {t('Skip Tutorial')}
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};
